export class DownloadSuccessModel {
  id?:string;
  title: string;
  subTitle?: string;
  buttonName?: string;
  downloading?: boolean;
}
